import React from "react";
import clsx from "clsx";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { List, ListItemText, ListItem } from "@material-ui/core";

export default function TailoringTipView(props) {
  const classes = props.classes;
  const balancePaper = clsx(classes.paper, classes.balanceCard);
  let cur_option = props.elem;
  let cur_dict = props.tailoringDict;
  let containerVal = 6;
  if (props.printout) {
    containerVal = 12;
  }
  return (
    <Grid item xs={containerVal}>
      <div>
        <Typography align="center">{cur_option}</Typography>
        <Paper className={balancePaper}>
          <Grid item xs={12}>
            <div className={classes.column}>
              <List dense>
                <ListItem>
                  <ListItemText primary={cur_dict[cur_option]["GUIDANCE"]} />
                </ListItem>
              </List>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className={classes.column}>
              <List dense>
                <ListItem>
                  <ListItemText primary={cur_dict[cur_option]["TIPS"]} />
                </ListItem>
              </List>
            </div>
          </Grid>
          <Grid item container xs={12}>
            <Grid item xs={4}>
              <div className={clsx(classes.column)}>
                <List dense>
                  <ListItem>
                    <ListItemText primary="Approval Authority" />
                  </ListItem>
                  {cur_dict[cur_option]["APPROVAL AUTHORITY"].map((val) => (
                    <ListItem
                      key={
                        "a" +
                        cur_dict[cur_option]["APPROVAL AUTHORITY"].indexOf(val)
                      }
                    >
                      <ListItemText secondary={val} />
                    </ListItem>
                  ))}
                </List>
              </div>
            </Grid>
            <Grid item xs={4}>
              <div className={clsx(classes.column)}>
                <List dense>
                  <ListItem>
                    <ListItemText primary="References" />
                  </ListItem>
                  {cur_dict[cur_option]["REFERENCE"].map((val) => (
                    <ListItem
                      key={"b" + cur_dict[cur_option]["REFERENCE"].indexOf(val)}
                    >
                      <ListItemText secondary={val} />
                    </ListItem>
                  ))}
                </List>
              </div>
            </Grid>
            <Grid item xs={4}>
              <div className={clsx(classes.column)}>
                <List dense>
                  <ListItem>
                    <ListItemText primary="Timing" />
                  </ListItem>
                  {cur_dict[cur_option]["TIMING"].map((val) => (
                    <ListItem
                      key={"c" + cur_dict[cur_option]["TIMING"].indexOf(val)}
                    >
                      <ListItemText secondary={val} />
                    </ListItem>
                  ))}
                </List>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className={clsx(classes.column)}>
                <List dense>
                  <ListItem>
                    <ListItemText primary="Resources" />
                  </ListItem>
                  {cur_dict[cur_option]["LINKS"].map((val) => (
                    <ListItem
                      key={val + cur_dict[cur_option]["LINKS"].indexOf(val)}
                    >
                      <ListItemText
                        secondary={
                          <a href={val} target="_blank>">
                            {val}
                          </a>
                        }
                      />
                    </ListItem>
                  ))}
                </List>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </div>
    </Grid>
  );
}
